import { FieldProp } from 'redux-form'
import { ArrivalDateBanner, ConsolidationText, RadioGroup } from './components'
import css from './consolidated-shipping-form-fields.scss'

interface FormFieldProps {
  consolidationChoice: FieldProp<string>
}

export default ({ consolidationChoice }: FormFieldProps) => (
  <div className={css.ConsolidatedShippingFormFields}>
    <ConsolidationText />
    <ArrivalDateBanner />
    <RadioGroup consolidationChoice={consolidationChoice} />
  </div>
)
